import styled from "styled-components";
import { theme } from "@themes";

export const GeneralAvailabilityMyCoach = styled.div`
  margin: 0 2em 0 0em;
  .react-calendar {
    border-color: ${({ theme }) => theme.primaryColorLight};
    border-radius: 4px;
    font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  }
  .react-calendar__tile--active {
    background: ${({ theme }) => theme.button.primary};
    :hover {
      background: ${({ theme }) => theme.secondaryPurpleOne};
    }
  }
  abbr[title] {
    text-decoration: none;
  }
`;

export const CalendarCoach = styled.div`
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  width: 100%;
  margin-left: 1.6em;
`;

export const CoachCard = styled.div`
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  border-top: 1px solid ${({ theme }) => theme.button.primary};
  width: 64.7vw;
  margin-left: 1em;
  margin-bottom: 2em;
`;

export const ImageCoach = styled.div`
  width: 90px;
  height: 90px;
  border-radius: 99px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-image: url(${(props) => props.previewImage});
`;

export const CoachTitle = styled.p`
  font-weight: normal;
  color: #1c1c1c;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  font-size: 18px;
`;

export const CoachDescription = styled.p`
  color: ${({ theme }) => theme.neutral.gray[2600]};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  font-size: 12px;
  display: flex;
  align-items: center;
`;

export const ContentDescriptLang = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;
`;

export const ButtonLink = styled.a`
  color: ${({ theme }) => theme.button.primary};
  font-size: 12px;
`;

export const TitleOfToday = styled.p`
  font-size: 12px;
  font-weight: 600;
  margin-left: 1.5em;
`;

export const HR = styled.hr`
  background-color: ${({ theme }) => theme.secondaryGrayLightThree};
  width: 96.5%;
`;

export const CardDayAvailable = styled.div`
  background-color: ${(props) =>
    props.activeCard.active === true || props.activeCard.id === props.id
      ? props.theme.secondaryPurpleOne
      : props.theme.secondaryGrayLightSeven};
  text-align: center;
  width: 9em;
  color: ${(props) =>
    props.activeCard.active === true || props.activeCard.id === props.id
      ? props.theme.primaryColorLight
      : props.theme.secondaryDarkOne};
  padding: 2em 0.5em;
  margin-bottom: 0.5em;
  cursor: pointer;
  :hover {
    color: ${({ theme }) => theme.primaryColorLight};
    background-color: ${({ theme }) => theme.secondaryPurpleOne};
  }
`;

export const DateAvailable = styled.div`
  font-size: 12px;
  font-weight: 600;
`;

export const HourAvailable = styled.div`
  font-size: 20px;
  font-weight: 300;
`;

export const ButtonRequest = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 36px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.button.primary};
  margin-top: 1em;
  margin-bottom: 1em;
  color: ${({ theme }) => theme.primaryColorLight};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.primaryGray};
    text-decoration: none;
    background-color: transparent;
  }
  :hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const ButtonCancel = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 36px;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.button.primary};
  margin: 1em auto;
  color: ${({ theme }) => theme.button.primary};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.primaryGray};
    text-decoration: none;
    background-color: transparent;
  }
  :hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
